@for (number of [].constructor(currentNumberOfPunctuation); track number) {
<mat-icon
  class="punctuation"
  [ngClass]="'color-' + (currentColor || 'black')"
  [svgIcon]="icon!"
></mat-icon>
}
<span class="text" [style.color]="currentColor || 'black'">{{
  currentText
}}</span>
